import { axiosApi, basePath } from "./api";

// 更新运营负责人
export function updateOperations (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/trader/operationsEmployee/update', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

// 启用签约
export function enableInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/trader/buyer/overdueOrder/enable', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

// 禁用签约
export function disableInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/trader/buyer/overdueOrder/disable', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

// 修改记录
export function logInfo (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/trader/buyer/signRecord/info', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}

// 编辑签约时间
export function signTimeUpdate (data={}) {
  return new Promise((resolve, reject) => {
    axiosApi('/trader/buyer/signTime/update', data, (res) => {
      if (res.data.code === "000000") {
        resolve(res.data.data)
      } else { 
        reject(res)
      }
    }, data.pageIndex||null, data.pageSize||null, (err) => { 
      reject(err)
    });
  })
}





